import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { Countdown } from './Countdown';
import { closeCompare, closeContent, urgency } from '../data/tables';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE } from '../data/config';
export function Close() {
  return <section aria-labelledby="close-heading" className="bg-ink" data-id="element-50" data-mp="1pzrposbmn6n5">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-51" data-mp="1q1m6bufv8clf">
        <div className="mx-auto max-w-[46rem]" data-id="element-52" data-mp="1l1gbk5eau9z4">
          <h2 id="close-heading" className="font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-paper md:text-[46px]" data-id="element-53" data-mp="1g8wzxdz69owy">
            {closeContent.heading}
          </h2>

          <p className="mt-7 text-[17px] leading-[1.65] text-paper/80 md:text-[18px]" data-id="element-54" data-mp="17a1rrwcki4r0">
            {closeContent.body}
          </p>

          <p className="mt-8 font-mono text-[11px] uppercase tracking-label text-brass" data-id="element-55" data-mp="12bs03vq1xma5">
            {closeContent.kicker}
          </p>

          {/* Mobile: stacked rows */}
          <ul className="mt-8 space-y-4 md:hidden" data-id="element-56" data-mp="3vdu6nouge98a">
            {closeCompare.map(row => <li key={row.without} className="border border-brass/40" data-id="element-57" data-mp="42ak9bp2jh82">
                <p className="border-b border-brass/25 px-5 py-4 text-[15px] leading-[1.5] text-paper/60" data-id="element-58" data-mp="3li0kreuuh3du">
                  {row.without}
                </p>
                <p className="px-5 py-4 text-[15px] font-medium leading-[1.5] text-paper" data-id="element-59" data-mp="3qdzbh93naxhf">
                  {row.with}
                </p>
              </li>)}
          </ul>

          {/* Desktop: table */}
          <table className="mt-10 hidden w-full border-collapse border border-brass/40 text-left md:table" data-id="element-60" data-mp="82ky1aj3rbxh">
            <thead data-id="element-61" data-mp="d0w7vl9edmfp">
              <tr data-id="element-62" data-mp="d04e8fzd1ys2">
                <th scope="col" className="w-1/2 border-b border-brass/40 bg-brass px-5 py-3 font-mono text-[10px] uppercase tracking-label text-ink" data-id="element-63" data-mp="czkvix1vz6cz">
                  Without the system
                </th>
                <th scope="col" className="w-1/2 border-b border-l border-brass/40 bg-brass px-5 py-3 font-mono text-[10px] uppercase tracking-label text-ink" data-id="element-64" data-mp="1497bic7gnsg2">
                  With the system
                </th>
              </tr>
            </thead>
            <tbody data-id="element-65" data-mp="pj018jrlxfqg">
              {closeCompare.map(row => <tr key={row.without} data-id="element-66" data-mp="kkyjc25x3mgk">
                  <td className="border-b border-brass/25 px-5 py-4 text-[15px] leading-[1.5] text-paper/60" data-id="element-67" data-mp="klzxwgm56r31">
                    {row.without}
                  </td>
                  <td className="border-b border-l border-brass/25 px-5 py-4 text-[15px] font-medium leading-[1.5] text-paper" data-id="element-68" data-mp="bk0a95gmgor4">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>

          <div className="mt-12 border border-brass/30 px-6 py-9 text-center md:px-10" data-id="element-69" data-mp="25xi2v6vvwbt0">
            <Countdown postCountdownLine={urgency.postCountdown} size="sm" data-id="element-70" data-mp="20zq17l5ftbbm" />

            <p className="mt-8 font-mono text-[13px] uppercase tracking-label text-paper/70" data-id="element-71" data-mp="28ho77foeu4a3">
              Everything above, normally{' '}
              <span className="text-brick line-through" data-id="element-72" data-mp="2dfpphye0hzki">{REGULAR_PRICE}</span> — today{' '}
              <span className="text-brass" data-id="element-73" data-mp="2i9aontrcczla">{PRICE} USD</span>.
            </p>

            <div className="mt-8" data-id="element-74" data-mp="2n6am5ga4ku0s">
              <CtaButton href={CHECKOUT_URL} data-id="element-75" data-mp="2n9gauueudtvz">Get the system now — {PRICE}</CtaButton>
              <TrustRow tone="dark" align="center" className="mt-4" data-id="element-76" data-mp="1ploajrkhmck6" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}